"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var querySelector_1 = require("./querySelector");
exports.dom = function (els) {
    var elements = function () {
        return els;
    };
    return {
        elements: elements,
    };
};
exports.domSelector = function (selector) {
    return exports.dom(querySelector_1.querySelector(selector));
};
exports.domOne = function (element) {
    return exports.dom([element]);
};
